import { render, staticRenderFns } from "./AbCheckbox.vue?vue&type=template&id=bed01814&scoped=true"
import script from "./AbCheckbox.vue?vue&type=script&lang=js"
export * from "./AbCheckbox.vue?vue&type=script&lang=js"
import style0 from "./AbCheckbox.vue?vue&type=style&index=0&id=bed01814&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed01814",
  null
  
)

export default component.exports